import React from 'react';
import {Box, Stack} from '@mui/material';

/** Same red → green ramp as ICD-203 / best-practices draft task cards. */
export const SEGMENT_METER_COLORS = [
    'error.dark',
    'error.main',
    'warning.dark',
    'warning.main',
    'warning.light',
    'success.light',
    'success.main',
];

export function segmentMeterFillColor(filled, total) {
    if (total <= 0 || filled <= 0) return SEGMENT_METER_COLORS[0];
    const colorIndex = Math.floor((filled / total) * (SEGMENT_METER_COLORS.length - 1));
    return SEGMENT_METER_COLORS[colorIndex] || SEGMENT_METER_COLORS[0];
}

/**
 * Horizontal segmented meter reused from draft ICD-203 compliance cards.
 * @param {'compact'|'default'} size — compact for inline Gaps similarity rows
 */
export default function SegmentedMeter({
    filled = 0,
    total = 5,
    size = 'default',
    'data-testid': testId,
    'aria-label': ariaLabel,
}) {
    const safeFilled = Math.max(0, Math.min(total, filled));
    const color = segmentMeterFillColor(safeFilled, total);
    const height = size === 'compact' ? 4 : 8;
    const spacing = size === 'compact' ? 0.25 : 0.5;
    const segmentWidth = size === 'compact' ? 10 : null;

    return (
        <Stack
            direction="row"
            spacing={spacing}
            alignItems="center"
            data-testid={testId}
            aria-label={ariaLabel}
            sx={size === 'default' ? {flex: 1, minWidth: 0} : undefined}
        >
            {Array.from({length: total}, (_, index) => (
                <Box
                    key={index}
                    data-testid={testId ? `${testId}-segment-${index + 1}` : undefined}
                    data-filled={index < safeFilled ? 'true' : 'false'}
                    sx={{
                        ...(segmentWidth ? {width: segmentWidth, flexShrink: 0} : {flex: 1}),
                        height,
                        borderRadius: height / 2,
                        bgcolor: index < safeFilled ? color : 'action.disabledBackground',
                        transition: 'background-color 0.2s',
                    }}
                />
            ))}
        </Stack>
    );
}
